import { AddLocationOutlined } from "@mui/icons-material";
import { Grid, Paper, Stack, Typography } from "@mui/material";
import { ButtonFilterCustom } from "components/StackCustom/styles";
import { mappedColorsHeatMapCards } from "pages/Dashboard";
import { Dispatch, SetStateAction } from "react";
import { applyFactorRGB } from "shared/helpers/dashboard";
import { ListaOrcamentoPorRegiao } from "shared/interfaces/dashboardSistemista";
import { DataPoint } from "shared/interfaces/heatMap";
import NewGrafico from "../NewGrafico";

export interface GraficoHeatMapProps {
  porcentagemOrcamentosPorRegiao?: ListaOrcamentoPorRegiao | null;
  selectedRegion: string;
  setSelectedRegion: Dispatch<SetStateAction<string>>;
  title: string;
}

export function GraficoHeatMap({
  porcentagemOrcamentosPorRegiao,
  selectedRegion,
  setSelectedRegion,
  title,
}: GraficoHeatMapProps) {
  const todasAsRegioes = [
    "Norte",
    "Nordeste",
    "Sudeste",
    "Sul",
    "Centro-Oeste",
  ];

  const allGeocodings = porcentagemOrcamentosPorRegiao
    ?.map(function (p) {
      return p.totalOrcamentosPorGeoCoding;
    })
    .reduce(function (a, b) {
      return a.concat(b);
    }, []);
  const dataPoints: DataPoint[] = allGeocodings?.map((item) => {
    return {
      longitude: item.longitude,
      latitude: item.latitude,
      count: item.totalOrcamentos,
    };
  })!;

  const porcentagemOrcamentos = todasAsRegioes.map((nomeRegiao, index) => {
    const regiaoEncontrada = porcentagemOrcamentosPorRegiao?.find(
      (item) => item.nomeRegiao === nomeRegiao
    );

    return {
      nomeRegiao,
      porcentagemOrcamentos: regiaoEncontrada?.porcentagemOrcamentos ?? 0,
    };
  });

  return (
    <Grid container>
      <Grid item md={4} mt={3}>
        {porcentagemOrcamentos?.map((regiao, index) => (
          <ButtonFilterCustom
            key={regiao.nomeRegiao}
            sx={{
              backgroundColor:
                selectedRegion === regiao.nomeRegiao || !selectedRegion
                  ? applyFactorRGB(mappedColorsHeatMapCards[index], 0)
                  : "rgba(211, 211, 211, 0.7)",
              color: "rgba(255, 255, 255, 1)",
              "&:hover": {
                backgroundColor: applyFactorRGB(
                  mappedColorsHeatMapCards[index],
                  -30
                ),
              },
              my: 1,
            }}
            onClick={() =>
              setSelectedRegion((prev) =>
                regiao.nomeRegiao === prev ? "" : regiao.nomeRegiao
              )
            }
          >
            <Typography sx={{ fontWeight: 400 }}>
              {regiao.nomeRegiao}
            </Typography>
            <Grid
              container
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Typography mt={1} mb={1} sx={{ fontWeight: 700 }}>
                {regiao.porcentagemOrcamentos}% orçamentos
              </Typography>
              <AddLocationOutlined />
            </Grid>
          </ButtonFilterCustom>
        ))}
      </Grid>
      <Grid item md={8} mt={1}>
        <Stack alignItems={"center"}>
          <Typography variant="h6" color={"primary.main"}>
            {title}
          </Typography>
          <Paper sx={{ padding: "10px" }}>
            <NewGrafico data={dataPoints} />
          </Paper>
          {/* <Paper sx={{ padding: "10px" }}>
            <NewdoNewGrafico data={dataPoints} />
          </Paper> */}
        </Stack>
      </Grid>
    </Grid>
  );
}
